import { CREATE_PLAYERS_LOADING, CREATE_PLAYERS_SUCCESS, CREATE_PLAYERS_ERROR } from "../../../constant/actionTypes";

const createPlayerReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_PLAYERS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case CREATE_PLAYERS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case CREATE_PLAYERS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default createPlayerReducer;